module.exports = "data:image/webp;base64,UklGRkwAAABXRUJQVlA4IEAAAACwBQCdASpkAGYAPpFIoUylpCMiIKgAsBIJaW7hc+AAY2upvcReWAa6m9xF5YBrqb3EXlgGngAA/v8nMAAAAAAA"